module.exports = __webpack_public_path__ + "static/media/flonne-happy.2b3bbca2.png";